// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { ResContactCategories_abstract } from './../../abstract/SagaBase/Objects/ResContactCategories_abstract';
export class ResContactCategories extends ResContactCategories_abstract {}
